import { createReducer, on } from '@ngrx/store';
import * as UserActions from './store.actions';

export interface UserState {
  users: { [id: string]: any };
}

export const initialState: UserState = {
  users: {},
};

export const userReducer = createReducer(
  initialState,

  on(UserActions.addUser, (state, { user }) => ({
    ...state,
    users: { ...state.users, [user.id]: user }
  })),

  on(UserActions.removeUser, (state, { userId }) => {
    const updatedUsers = { ...state.users };
    delete updatedUsers[userId];
    return { ...state, users: updatedUsers };
  }),

  on(UserActions.updateUser, (state, { user }) => ({
    ...state,
    users: { ...state.users, [user.id]: { ...state.users[user.id], ...user } }
  }))
);
